export default __webpack_public_path__ + "static/media/left-arrow.d32bf53d.svg";